export default "__VITE_ASSET__5XmuXi2nU8PVp$7eVRd8Nw__"